<template>
    <AppFormValidator
        ref="validator"
        #default="{ errors }"
        :model="model"
        :rules="rules">
        <CForm>
            <CInput
                v-model="model.description"
                label="Краткое описание"
                placeholder="Укажите краткое описание (не более 255 символов)"
                :is-valid="errors.description && errors.description.isValid" />

            <CInput
                v-model="model.phone"
                label="Телефон"
                :is-valid="errors.phone && errors.phone.isValid" />
                
            <CRow>
                <CCol
                    tag="label"
                    sm="3"
                    class="col-form-label">
                    Расширенное время работы (Пример: с 07:00, до 02:00 след. дня)
                </CCol>
                <CCol sm="9">
                    <CSwitch
                        color="dark"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.extended_schedule"
                    />
                </CCol>
            </CRow>

            <div class="flex items-center">
                <CInput
                    v-model="model.min_price"
                    class="w-1/2"
                    label="Минимальный заказ"
                    :invalid-feedback="errors.min_price && errors.min_price.message"
                    :is-valid="errors.min_price && errors.min_price.isValid" />
                <div class="mx-4"></div>
            </div>

            <div class="flex items-center">
                <CInput
                    v-model="model.delivery_time_hour"
                    class="w-1/2"
                    label="Время доставки (часы)"
                    :is-valid="errors.delivery_time_hour && errors.delivery_time_hour.isValid" />
                <div class="mx-4"></div>
                <CInput
                    v-model="model.delivery_time"
                    class="w-1/2"
                    label="Время доставки (минуты)"
                    :is-valid="errors.delivery_time && errors.delivery_time.isValid" />
            </div>

            <div class="flex items-center">
                <div class="w-1/2">
                    Изображение
                    <CInputFile
                        class="border"
                        custom
                        :placeholder="
                            model.picture ? model.picture : 'Выберите изображение'
                        "
                        :is-valid="errors.picture && errors.picture.isValid"
                        @change="uploadPicture" />
                </div>
                <div class="mx-4"></div>
                <div class="w-1/2">
                    Изображение для поиска
                    <CInputFile
                        class="border"
                        custom
                        :placeholder="
                            model.square_picture ? model.square_picture : 'Выберите изображение для поиска'
                        "
                        :is-valid="errors.square_picture && errors.square_picture.isValid"
                        @change="uploadSquarePicture" />
                </div>
                <div class="mx-4"></div>
                
            </div>
            <div class="flex items-center">
                <div class="flex items-center w-1/2">
                    <div class="col-form-label">Активен</div>

                    <CSwitch
                        class="ml-4"
                        color="success"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.enabled" />
                </div>
            </div>
        </CForm>

        <div class="flex mt-4">
            <CButton color="primary" @click="submit">{{ submitButtonTitle }}</CButton>
        </div>

        <AppConfirmDialog
            ref="confirmDialog"
            title="Подтверждение"
            color="danger"
            text="Вы действительно хотите удалить запись? Это действие нельзя будет отменить."
            @confirm="confirmDelete" />
    </AppFormValidator>
</template>

<script>
    import to from 'await-to-js';
    import { morphism } from 'morphism';
    import { requiredRule, xssRegEx } from '@/utils/rules';

    import AppFormValidator from '@/components/AppFormValidator';
    import AppConfirmDialog from '@/components/AppConfirmDialog';
    import { translit } from '@/utils/translit';

    export default {
        components: {
            AppFormValidator,
            AppConfirmDialog,
        },

        props: {
            entity: {
                type: Object,
                default: () => ({}),
            },
        },

        data: () => ({
            isPending: false,
            schedule: undefined,
            model: {},
            schema: {
                id: 'id',
                code: 'code',
                legal_entity: 'legal_entity',
                title: 'title',
                short_title: 'short_title',
                description: 'description',
                picture: 'picture',
                square_picture: 'square_picture',
                phone: 'phone',
                data_url: 'data_url',
                extended_schedule: 'extended_schedule',
                min_price: source =>
                    typeof source.min_price === 'number'
                        ? source.min_price.toString()
                        : undefined,
                delivery_time_hour: source =>
                    typeof source.delivery_time_hour === 'number'
                        ? source.delivery_time_hour.toString()
                        : undefined,
                delivery_time: source =>
                    typeof source.delivery_time === 'number'
                        ? source.delivery_time.toString()
                        : undefined,
                position: source => (source.position ? source.position : 1),
                enabled: source =>
                    typeof source.enabled === 'boolean' ? source.enabled : false,
            },
            rules: {
                title: [requiredRule],
                code: [requiredRule],
                description: [requiredRule],
                picture: [requiredRule],
                phone: [requiredRule],
                delivery_time: [
                    {
                        type: 'string',
                        pattern: /^[0-9]*$/,
                        message: 'Укажите в цифрах',
                    },
                ],
                delivery_time_hour: [
                    {
                        type: 'string',
                        pattern: /^[0-9]*$/,
                        message: 'Укажите в цифрах',
                    },
                ],
                min_price: [
                    {
                        type: 'string',
                        pattern: /^[1-9]{1}[0-9]*$/,
                        message: 'Укажите в цифрах или оставьте поле пустым',
                    },
                ],
            },
        }),

        computed: {
            submitButtonTitle() {
                return typeof this.entity.id === 'number' ? 'Сохранить' : 'Создать';
            },
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings'))
                    .is_business_admin;
            },
            computedCode() {
                if (!this.entity.code) {
                    this.model.code = translit(
                        this.model.title ? this.model.title : ''
                    );
                }
                return this.model.code;
            },
        },

        created() {
            this.setModel();
        },

        methods: {
            setSchedule(schedule) {
                this.schedule = schedule;
            },

            setModel() {
                this.model = morphism(this.schema, this.entity);
                if (!this.entity.schedule) {
                    this.entity.schedule = [];
                }
                this.setSchedule(this.entity.schedule);
            },

            async uploadPicture(FileList) {
                const form = new FormData();
                form.append('file', FileList[0]);

                const [err, result] = await to(
                    this.axios.post('/files/upload', form)
                );

                if (err) {
                    this.$root.$emit('showError', 'Ошибка. Не удалось загрузить картинку.');
                }

                this.model.picture = result.data.filename;
            },

            async uploadSquarePicture(FileList) {
                const form = new FormData();
                form.append('file', FileList[0]);

                const [err, result] = await to(
                    this.axios.post('/files/upload', form)
                );

                if (err) {
                    this.$root.$emit('showError', 'Ошибка. Не удалось загрузить картинку.');
                }

                this.model.square_picture = result.data.filename;
            },

            async submit() {
                const [error] = await to(this.$refs.validator.validate());

                if (error) {
                    return false;
                }

                const { id, ...payload } = this.model;
                if (xssRegEx.test(payload.description)) {
                    this.$root.$emit('showError', 'Описание содержит недопустимые символы.')
                    return
                }

                payload.extended_schedule = !!payload.extended_schedule;
                payload.position = parseInt(payload.position);
                payload.delivery_time = payload.delivery_time
                    ? parseInt(payload.delivery_time)
                    : 0;
                payload.delivery_time_hour = payload.delivery_time_hour
                    ? parseInt(payload.delivery_time_hour)
                    : 0;
                payload.min_price = payload.min_price
                    ? parseInt(payload.min_price)
                    : 0;
                payload.data_url = payload.data_url ? payload.data_url : '';
                payload.schedule = this.schedule;

                if (typeof id === 'number') {
                    const [err] = await to(
                        this.axios.put(`/pharmacies/${id}`, payload)
                    );
                    if (err) {
                        return this.$root.$emit('showError', 'Ошибка. Не удалось сохранить запись.');
                    }
                } else {
                    const [err] = await to(this.axios.post('/pharmacies', payload));
                    if (err) {
                        return this.$root.$emit('showError', 'Ошибка. Не удалось создать новую запись.');
                    }
                }

                this.$emit('success');
            },

            async confirmDelete() {
                if (!this.model.id) {
                    return false;
                }

                const [error] = await to(
                    this.axios.delete(`/pharmacies/${this.model.id}`)
                );

                if (error) {
                    this.$root.$emit('showError', 'Ошибка удаления.');
                }

                this.$emit('deleted');
            },
        },
    };
</script>
